var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45833 7.42262C8.45833 5.63458 9.98953 4.125 11.9583 4.125C13.9271 4.125 15.4583 5.63458 15.4583 7.42262V9.70898H8.45833V7.42262ZM6.95833 9.70898V7.42262C6.95833 4.73802 9.23091 2.625 11.9583 2.625C14.6858 2.625 16.9583 4.73802 16.9583 7.42262V9.70898H17.4226C18.6435 9.70898 19.7917 10.6147 19.7917 11.9014V18.212C19.7917 19.8953 18.2792 21.1257 16.6131 21.1257H7.30357C5.63744 21.1257 4.125 19.8953 4.125 18.212V11.9014C4.125 10.6148 5.27316 9.70898 6.49405 9.70898H6.95833ZM5.625 11.9014C5.625 11.6014 5.93398 11.209 6.49405 11.209H17.4226C17.9827 11.209 18.2917 11.6014 18.2917 11.9014V18.212C18.2917 18.9087 17.6184 19.6257 16.6131 19.6257H7.30357C6.29827 19.6257 5.625 18.9087 5.625 18.212V11.9014Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })));
};
export default SvgLock;